import * as APIRoutes from '@mm/api-routes';
import {
  ConvertationRequest,
  ConvertationRequestStatus,
  ConvertLeadsResponse,
  LeadsSearchQuery,
  LeadsSearchResponse,
  SearchAttributes,
} from '../interfaces/leads';
import AuthenticatedController from './AuthenticatedController';

export default class LeadsController extends AuthenticatedController {
  static async getAllAttributes(): Promise<SearchAttributes> {
    return super.get(APIRoutes.LEADS_ATTRIBUTES);
  }

  static async searchLeads(
    params: LeadsSearchQuery,
  ): Promise<LeadsSearchResponse> {
    return super.post(APIRoutes.LEADS_SEARCH, params);
  }

  static async retrieveLocationAttributes(
    query: string,
  ): Promise<SearchAttributes> {
    return super.post(APIRoutes.LEADS_ADDRESS_ATTRIBUTE_SEARCH, { query });
  }

  static async convertSearchedLeadsToContacts(
    fbPageId: number,
    params: ConvertationRequest,
  ): Promise<ConvertLeadsResponse> {
    return super.post(APIRoutes.LEADS_CONVERTATION_REQUESTS(fbPageId), params);
  }

  static async getConvertationRequests(
    fbPageId: number,
    status?: ConvertationRequestStatus,
  ): Promise<ConvertLeadsResponse[]> {
    return super.get(APIRoutes.LEADS_CONVERTATION_REQUESTS(fbPageId, status));
  }
}
